<script setup lang="ts">
import useTranslation from "@Composables/useTranslation"

//
// Setup
const { __ } = useTranslation()
</script>

<template>
  <div class="org-past-due-banner _past_due_banner">
    {{ __("plan_information_banner.past_due") }}
    {{ __("plan_information_banner.contact_support") }}
    <router-link
      class="org-past-due-banner__contact-link _contact_link"
      :to="{ name: 'freescout' }"
    >
      <span>{{ __("plan_information_banner.contact_us") }}</span>
    </router-link>.
  </div>
</template>

<style lang="scss" scoped>
@use "@tinyurldev/tu-ui-vue/scss/settings/colors.scss" as color;

.org-past-due-banner {
  &__contact-link {
    color: color.$text-white;
    text-decoration: underline;
  }
}
</style>
